import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import {
  MissingExemptionCustomerId,
  MissingExemptionCustomerIdAndName,
  MissingExemptionCustomerName,
} from 'src/common/helpers/error-code';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import {
  getExemptibleTax,
  getExemptibleTaxByLine,
} from '../business-logic/service/get-exemptible-tax';
import {
  modifyExemptions,
  separateAuthorities,
  updateEJState,
} from '../business-logic/tax-exemption';
import { showCustomerNameEntryModal } from '../components/customer-name-entry-modal';
import { showCustomerTaxIdInputModal } from '../components/customer-tax-id-modal';
import { ExemptibleTax } from '../interfaces/exemptible-tax.interface';
import { ApplyTaxExemptionDTO } from '../interfaces/tax-exemption.interface';

export const handleTaxExemption = async (taxData: TaxExemptionData, modalId: string) => {
  const { transactionId, taxExemptionDTO, lineId } = taxData;

  const taxList = await getTaxList(transactionId, lineId);
  const { currentlyNotExempted, currentlyExempted } = separateAuthorities(taxList);

  const cartResponse = await modifyExemptions(
    transactionId,
    currentlyNotExempted,
    currentlyExempted,
    lineId,
    taxExemptionDTO,
  );
  updateEJState(cartResponse);
  popEmeraldModal(modalId);
};

export const handleTaxException = (error: any, taxData: TaxExemptionData) => {
  if (
    error.code === MissingExemptionCustomerIdAndName ||
    error.code === MissingExemptionCustomerId
  ) {
    taxData.taxExemptionErrorCode = error.code;
    showCustomerTaxIdInputModal(taxData);
  } else if (error.code === MissingExemptionCustomerName) {
    showCustomerNameEntryModal(taxData);
  } else {
    popupMessage(error);
  }
};

export const getTaxList = async (
  transactionId: string,
  lineId?: string,
): Promise<ExemptibleTax[]> => {
  const taxList = lineId
    ? await getExemptibleTaxByLine(transactionId, lineId)
    : await getExemptibleTax(transactionId);
  return taxList;
};

export interface TaxExemptionData {
  taxExemptionErrorCode: string;
  transactionId: string;
  taxExemptionDTO: ApplyTaxExemptionDTO;
  lineId?: string;
}
